import Vue from 'vue'
import { Message } from 'ant-design-vue'
import { Toast } from 'cube-ui'
import { decode } from './mix'
import { uploadConvert } from '@/services/index'
import selefToast from '@/components/mobile/Toast/index'
import { setLang, getLang } from './storage'
import i18n from './language'
/**
 * 判断基本类型
 * @param {*} obj 任意值
 */
export const toType = obj => {
  return Object.prototype.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase()
}
export const getLocalTime = (offset = 0, nowTime) => {
  if (!offset) return
  let d = nowTime ? new Date(nowTime) : new Date()
  let localTime = d.getTime()
  let localOffset = d.getTimezoneOffset() * 60000 // getTimezoneOffset()返回是以分钟为单位，需要转化成ms
  let utc = localTime + localOffset
  // offset = 9 // 以韩国时间为例，东9区
  let korean = utc + (3600000 * offset)
  let nd = new Date(korean)
  console.log('Korean time is ' + nd.toLocaleString())
  return nd
}
export const jsonToBase64 = json => {
  const str = encodeURIComponent(JSON.stringify(json))
  return window.btoa(str)
}
export const base64ToJson = base64Str => {
  // const json = JSON.parse(jsonStr)
  const jsonStr = decodeURIComponent(window.atob(base64Str))
  return JSON.parse(jsonStr)
}
/**
 * 提示函数
 * 显示三秒后关闭
 * type: Number (success/error)等 0: error, 1: success
 * msg: String
 * duration: Number
 * iconClass: String
 */
export const tip = (type, msg, title, duration, iconClass) => {
  if (window.ua.isPhone) {
    duration = duration || 3000 // 默认持续时间

    window.toast = Toast.$create({
      type: type ? 'success' : 'error',
      txt: msg,
      time: duration,
      icon: 'iconfont icon-icon_rightcopy',
      mask: true,
      $events: {
        timeout: () => {
          // 当显示时间结束时派发
          console.log('Timeout')
        }
      }
    })
    window.toast.show()
  } else {
    Message.destroy() // 先关闭，避免不停触发弹窗

    duration = duration || 3000 // 默认持续时间
    window.toast = Message.open({
      title: title || '',
      content: msg,
      duration,
      type: type ? 'success' : 'error',
      onClose: () => {
        console.log('Timeout')
      }
    })
  }
}

/**
 * 过滤掉发送请求时，参数空数据的函数
 *
 * @export
 * @param {Object} param
 * @returns
 */
export const requestDataFilterNull = param => {
  for (var key in param) {
    if (param[key] == null || param[key] === '') {
      delete param[key]
    }
    if (toType(param[key]) === 'string') {
      param[key] = param[key].trim()
    } else if (toType(param[key]) === 'object') {
      param[key] = requestDataFilterNull(param[key])
    } else if (toType(param[key]) === 'array') {
      param[key] = requestDataFilterNull(param[key])
    }
  }
  return param
}

/**
 * 发送请求时，参数处理成 key: value 格式
 *
 * @export
 * @param {Object} param
 * @returns
 */
export const requestDataToKeyValue = param => {
  for (var key in param) {
    if (param[key] == null || param[key] === '') {
      continue
    }
    if (toType(param[key]) === 'string') {
      param[key] = param[key].trim()
    } else if (toType(param[key]) === 'object') {
      param[key] = requestDataToKeyValue(param[key])
    } else if (toType(param[key]) === 'array') {
      param[key] = requestDataToKeyValue(param[key])
    }
  }
  return param
}

/**
 * 隐藏电话号码中间 5 位
 * @param {String} val 电话号码
 */
export function hiddenPhone (val) {
  // console.log(val)
  return val && val.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
}

/**
 * 获取字符串长度,汉字算两个字符
 * @param {String} str 字符串
 */
export function getStrleng (str) {
  let maxstrlen = 160
  let myLen = 0
  let i = 0
  for (; i < str.length && myLen <= maxstrlen * 2; i++) {
    if (str.charCodeAt(i) > 0 && str.charCodeAt(i) < 128) {
      myLen++
    } else {
      myLen += 2
    }
  }
  return myLen
}
/**
 * 获取字符串长度,汉字算1个字符，英文算0.5个字符
 * @param {String} str 字符串
 */
export function getZhStrlen (str) {
  let maxstrlen = 160
  let myLen = 0
  let i = 0
  for (; i < str.length && myLen <= maxstrlen * 2; i++) {
    if (str.charCodeAt(i) > 0 && str.charCodeAt(i) < 128) {
      myLen++
    } else {
      myLen += 2
    }
  }
  return Math.ceil(myLen / 2)
}

/**
 * 将字符串截取为指定长度
 * @param {String} val 字符串
 * @param {Number} num 长度值
 */
/* export function substr (val, num) {
  if (val && toType(val) === 'string') {
    return getStrleng(val) > num * 2 ? val.substring(0, num) + '...' : val
  } else {
    return ''
  }
} */
/**
 * 将字符串截取为指定长度
 * 这个方法截取的有点问题，以后使用下面的方法
 * @param {String} val 字符串
 * @param {Number} num 长度值
 * @param {Boolean} hasSpot 是否有神略号，默认true
 */
export function substr (val, num, hasSpot) {
  let spot = '...'
  if (hasSpot === false) {
    spot = ''
  }
  if (typeof val === 'string') {
    return getStrleng(val) > num ? val.substring(0, num) + spot : val
  } else {
    return ''
  }
}
/**
 * 将字符串截取为指定长度,中文等于两个英文字符
 * @param {String} str 字符串
 * @param {Number} len 长度值
 * @param {Boolean} hasSpot 是否有神略号，默认true
 */
export function subZhStr (str, len, hasSpot) {
  if (!str || !len) {
    return ''
  }
  let spot = '...'
  if (hasSpot === false) {
    spot = ''
  }
  // 预期计数：中文2字节，英文1字节
  let a = 0
  // 循环计数
  let i = 0
  // 临时字串
  let temp = ''
  for (i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 255) {
      // 按照预期计数增加2
      a += 2
    } else {
      a++
    }
    // 如果增加计数后长度大于限定长度，就直接返回临时字符串
    if (Math.ceil(a / 2) > len) {
      return temp + spot
    }
    // 将当前内容加到临时字符串
    temp += str.charAt(i)
  }
  // 如果全部是单字节字符，就直接返回源字符串
  return temp
}

// 输出base64编码
export function base64 (str) {
  return window.btoa(unescape(encodeURIComponent(str)))
}
//  解码
export const decodeBase64 = encodeData => {
  return window.atob(encodeData)
}

export function exportExcel (titles, jsonData) {
  if (!jsonData || !jsonData.length) return

  // 列标题
  let str = ''
  str += '<tr>'
  for (let item of titles) {
    // 增加\t为了不让表格显示科学计数法或者其他格式
    str += `<td>${item + '\t'}</td>`
  }
  str += '</tr>'
  // 循环遍历，每行加入tr标签，每个单元格加td标签
  for (let row of jsonData) {
    str += '<tr>'
    for (let k in row) {
      const column = row[k]
      // 增加\t为了不让表格显示科学计数法或者其他格式
      str += `<td>${column + '\t'}</td>`
    }
    str += '</tr>'
  }
  // Worksheet名
  let worksheet = 'Sheet1'
  let uri = 'data:application/vnd.ms-excel;base64,'

  // 下载的表格模板数据
  let template = `<html xmlns:o="urn:schemas-microsoft-com:office:office"
  xmlns:x="urn:schemas-microsoft-com:office:excel"
  xmlns="http://www.w3.org/TR/REC-html40">
  <head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
    <x:Name>${worksheet}</x:Name>
    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet>
    </x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
    </head><body><table style="border: solid 1px #000;">${str}</table></body></html>`

  // 下载模板
  // window.location.href = uri + base64(template)
  let downloadLink = document.createElement('a')
  downloadLink.href = uri + base64(template)
  downloadLink.download = i18n.t('message["1222"]') + '.xls'
  downloadLink.click()
}

/**
 * 判断是否是父元素
 * @param {elementObj} currentElement 当前元素
 * @param {elementObj} parentElement 父级元素 返回true； 自己元素 返回false
 */
export function isParent (currentElement, parentElement) {
  while (
    currentElement !== undefined &&
    currentElement != null &&
    currentElement.tagName.toUpperCase() !== 'BODY'
  ) {
    if (currentElement === parentElement) {
      return true
    }
    currentElement = currentElement.parentNode
  }
  return false
}

// 获取滚动条高度
export function getScrollTop () {
  var scrollTop = 0
  if (document.documentElement && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop
  } else if (document.body) {
    scrollTop = document.body.scrollTop
  }
  return scrollTop
}

// 获取滚动距离(宽， 高)
export function getPageScroll () {
  let xScroll, yScroll
  if (self.pageYOffset) {
    yScroll = self.pageYOffset
    xScroll = self.pageXOffset
  } else if (document.documentElement && document.documentElement.scrollTop) {
    // Explorer 6 Strict
    yScroll = document.documentElement.scrollTop
    xScroll = document.documentElement.scrollLeft
  } else if (document.body) {
    // all other Explorers
    yScroll = document.body.scrollTop
    xScroll = document.body.scrollLeft
  }
  const arrayPageScroll = {
    left: xScroll,
    top: yScroll
  }
  return arrayPageScroll
}

// 获取页面的高度、宽度
export function getPageSize () {
  let xScroll, yScroll
  let pageHeight, pageWidth
  let windowWidth, windowHeight
  let arrayPageSize

  if (window.innerHeight && window.scrollMaxY) {
    xScroll = window.innerWidth + window.scrollMaxX
    yScroll = window.innerHeight + window.scrollMaxY
  } else {
    if (document.body.scrollHeight > document.body.offsetHeight) {
      // all but Explorer Mac
      xScroll = document.body.scrollWidth
      yScroll = document.body.scrollHeight
    } else {
      // Explorer Mac...would also work in Explorer 6 Strict, Mozilla and Safari
      xScroll = document.body.offsetWidth
      yScroll = document.body.offsetHeight
    }
  }
  if (self.innerHeight) {
    // all except Explorer
    if (document.documentElement.clientWidth) {
      windowWidth = document.documentElement.clientWidth
    } else {
      windowWidth = self.innerWidth
    }
    windowHeight = self.innerHeight
  } else {
    if (document.documentElement && document.documentElement.clientHeight) {
      // Explorer 6 Strict Mode
      windowWidth = document.documentElement.clientWidth
      windowHeight = document.documentElement.clientHeight
    } else {
      if (document.body) {
        // other Explorers
        windowWidth = document.body.clientWidth
        windowHeight = document.body.clientHeight
      }
    }
  }
  // for small pages with total height less then height of the viewport
  if (yScroll < windowHeight) {
    pageHeight = windowHeight
  } else {
    pageHeight = yScroll
  }
  // for small pages with total width less then width of the viewport
  if (xScroll < windowWidth) {
    pageWidth = xScroll
  } else {
    pageWidth = windowWidth
  }
  arrayPageSize = { pageWidth, pageHeight, windowWidth, windowHeight }
  return arrayPageSize
}

/**
 * 获取版心的宽度 sectionWidth
 */
export function getSectionWidth () {
  let width = 1280
  if (getPageSize().pageWidth < 1280) {
    width = getPageSize().pageWidth
  }
  return width
}

/**
 * 设置页面右侧底部 保存按钮 fixed 定位
 */
export function setFooterStyle (target, callback) {
  target.$nextTick(() => {
    if (!target.$refs.footer) return

    const $footer = target.$refs.footer

    $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
    const sectionWidth = target.$getSectionWidth()
    const pageWidth = target.$getPageSize().pageWidth
    if ($footer.parentNode.offsetTop - target.$getScrollTop() - window.innerHeight + $footer.parentNode.offsetHeight + 44 < 0) {
      $footer.style.position = 'absolute'
      $footer.style.left = 200 + 'px'
    } else {
      $footer.style.position = 'fixed'
      $footer.style.left = pageWidth <= sectionWidth ? $footer.parentNode.offsetLeft + 1 + 'px' : $footer.parentNode.offsetLeft + (pageWidth - sectionWidth) / 2 + 1 + 'px'
    }
    callback && callback()
  })
}

/**
 * 表单参数值的内容加密
 * @param {String} value // 参数值的内容
 */
export const setCodeData = async (value, codeFn) => {
  let result
  if (codeFn === undefined) {
    codeFn = decode
  }
  if (toType(value) === 'string' || toType(value) === 'number') {
    if (value === '' || value === 0) {
      result = value
    } else {
      result = await codeFn(value)
    }
  } else if (toType(value) === 'array') {
    // result = await Promise.all(
    //   value.map(async val => {
    //     return (async () => {
    //       val = await codeFn(val)
    //       return val
    //     })()
    //   })
    // )
    const arr = []
    for (let item of value) {
      if (item) {
        const newItem = await codeFn(item)
        arr.push(newItem)
      }
    }
    result = arr
  } else if (toType(value) === 'object') {
    // 暂无，排除掉
  } else {
    result = value
  }
  // console.log('result', result)
  return result
}

// 防止浏览器拦截新窗口
export const windowOpen = (url, target) => {
  let a = document.createElement('a')
  a.setAttribute('href', url)
  if (target == null) {
    target = ''
  }
  a.setAttribute('target', target)
  a.setAttribute('download', true)
  document.body.appendChild(a)
  if (a.click) {
    a.click()
  } else {
    try {
      let evt = document.createEvent('Event')
      a.initEvent('click', true, true)
      a.dispatchEvent(evt)
    } catch (e) {
      window.open(url)
    }
  }
  document.body.removeChild(a)
}

export const downloadFile = async (url = '', target) => {
  let newUrl = await reSetFileUrl(url, { _upd: true })
  if (newUrl) {
    // location.href = newUrl + '&_upd=true&amp;fromType=edit'
    windowOpen(newUrl, target)
  } else {
    windowOpen(url, target)
  }
}

/**
 * 重新设置上传后的图片地址
 * @param {url} 原来图片地址，路径如/images/3b2da96470c15fa50cbf5k405d851f93.png，不加域名和参数
 * @param {params} { _upd: true } _upd参数：图片是否下载
 */
export const reSetFileUrl = (url, params = {}) => {
  if (url) {
    if (url.indexOf('resource.westartrack.com') !== -1) {
      url = url.split('resource.westartrack.com')[1]
    }
    if (url.indexOf('?') !== -1) {
      url = url.split('?')[0]
    }
    return new Promise(async (resolve, reject) => {
      const chain = uploadConvert()
      await chain
        .params({
          url,
          ...params
        })
        .onSuccess(payload => {
          resolve(payload || '')
        })
        .fetch()
    })
  }
}

export const getQueryString = (name) => {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2]); return null
}

/**
 * 获取语言版本
 */
export const getLanguage = type => {
  let lang = type || getLang()
  lang = lang === 'en' ? 'zh' : 'en'
  // const language = lang === 'en' ? 'en' : 'zh-CN'

  setLang(lang)
  // store.commit('setLang', lang)
  // document.getElementsByTagName('html')[0].setAttribute('lang', language)
  document.body.setAttribute('lang', lang)
  i18n.locale = lang
  window.location.reload()
}
/**
   * @desc 函数防抖
   * 函数防抖运用的实际场景有：实时搜索，拖拽，登录用户名密码格式验证等
   * 短时间内多次触发同一事件，只执行最后一次，或者只执行最开始的一次，中间的不执行。
   * @param fn 目标函数
   * @param delay 延迟执行毫秒数
   */
export const debounce = function (fn, delay) {
  let timer
  return (...args) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}
/**
 * @desc 函数节流
 * 函数节流运用的实际场景有：窗口调整，页面滚动，抢购疯狂点击等
 * 指连续触发事件但是在 n 秒中只执行一次函数。即 2n 秒内执行 2 次... 。节流如字面意思，会稀释函数的执行频率。
 * @param func 函数
 * @param wait 延迟执行毫秒数
 */
export const throttle = (func, wait) => {
  let timeout
  return function () {
    let context = this
    let args = arguments
    if (!timeout) {
      timeout = setTimeout(() => {
        timeout = null
        func.apply(context, args)
      }, wait)
    }
  }
}

export function scalePx (num) {
  let screenWidth = getPageSize().windowWidth
  // 1920/screenWidth = 140 / x
  // console.log(getPageSize())
  return (num * screenWidth) / 375
}

Vue.use(selefToast)
Vue.prototype.$selefToast = selefToast
Vue.prototype.$toType = toType
Vue.prototype.$tip = tip
Vue.prototype.$requestDataFilterNull = requestDataFilterNull
Vue.prototype.$hiddenPhone = hiddenPhone
Vue.prototype.$getStrleng = getStrleng
Vue.prototype.$substr = substr
Vue.prototype.$getZhStrlen = getZhStrlen
Vue.prototype.$subZhStr = subZhStr
Vue.prototype.$isParent = isParent
Vue.prototype.$getScrollTop = getScrollTop
Vue.prototype.$getPageScroll = getPageScroll
Vue.prototype.$getPageSize = getPageSize
Vue.prototype.$getSectionWidth = getSectionWidth
Vue.prototype.$getLocalTime = getLocalTime
Vue.prototype.$windowOpen = windowOpen
Vue.prototype.$downloadFile = downloadFile
Vue.prototype.$reSetFileUrl = reSetFileUrl
Vue.prototype.$getQueryString = getQueryString
Vue.prototype.$decodeBase64 = decodeBase64
Vue.prototype.$getLanguage = getLanguage
Vue.prototype.$debounce = debounce
Vue.prototype.$throttle = throttle
Vue.prototype.$scalePx = scalePx
